import HeaderBar from "components/ui/HeaderBar"
import MainNavigation from "components/ui/MainNavigation"
import { useState } from "react"
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthLanding = ()=>{
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const navigate = useNavigate();
    const handleToggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };
    return(
        <div className="min-h-screen bg-background">
            {/* Header */}
            <HeaderBar 
                onToggleSidebar={handleToggleSidebar}
                isSidebarCollapsed={isSidebarCollapsed}
            />
            {/* Sidebar Navigation */}
            <MainNavigation 
                isCollapsed={isSidebarCollapsed}
                className="hidden lg:block"
            />

            {/* Main Content */}
            <main 
                className={`pt-16 transition-all duration-300 ease-out ${
                isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
                }`}
            >
                <Outlet/>
            </main>
        </div>
    )
}

export default AuthLanding;